import React, { useEffect } from "react";
import { CalendarDays } from "lucide-react";

// Embeds a GoHighLevel / LeadConnector booking calendar. The user picks a
// time slot, then enters their details — completing the whole process in the CRM.
const BOOKING_ID = "mXeN2M5uVQJIoh1zWkVo";

const GHLBooking = () => {
  // Re-run the embed script so form_embed.js attaches to this booking iframe
  // and auto-resizes it to its full content height (prevents cut-off).
  useEffect(() => {
    const existing = document.getElementById("ghl-booking-embed-script");
    if (existing) existing.remove();
    const s = document.createElement("script");
    s.id = "ghl-booking-embed-script";
    s.src = "https://link.msgsndr.com/js/form_embed.js";
    document.body.appendChild(s);
  }, []);

  return (
    <section className="bg-brand-cream py-16" id="book" data-testid="ghl-booking-section">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-8">
          <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
            Book Online
          </p>
          <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl leading-tight">
            Schedule Your Free Inspection
          </h2>
          <p className="text-slate-600 mt-3 max-w-xl mx-auto">
            Pick a time that works for you — then add your details. That's it.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl border border-black/5">
          <div className="bg-brand-navy px-6 py-5 flex items-center gap-3 rounded-t-3xl">
            <div className="w-10 h-10 rounded-full bg-brand-orange flex items-center justify-center shrink-0">
              <CalendarDays className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-display font-bold text-white text-lg leading-tight">
                Choose Your Appointment
              </h3>
              <p className="text-white/60 text-sm">Free · No obligation</p>
            </div>
          </div>
          <div className="p-2 sm:p-3">
            <iframe
              data-testid="ghl-booking-iframe"
              src={`https://api.leadconnectorhq.com/widget/booking/${BOOKING_ID}`}
              style={{ width: "100%", height: "1000px", border: "none", borderRadius: "12px" }}
              scrolling="yes"
              id={BOOKING_ID}
              title="Book an appointment with Fab Build Pro"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GHLBooking;
